import { Box, Container, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import PricingTable from '../components/Landing/PricingTable';
import FAQSection from '../components/Landing/FAQSection';
import FinalCTA from '../components/Landing/FinalCTA';
import { usePricing } from '../hooks/usePricing';

function Pricing() {
  const { t } = useTranslation();
  const { pricing, loading: pricingLoading } = usePricing();

  return (
    <Box sx={{ mt: 0, pt: 0 }}>
      {/* Hero Section */}
      <Box
        component="section"
        sx={{
          pt: { xs: 6, md: 8 },
          pb: { xs: 8, md: 10 },
          width: '100vw',
          marginLeft: 'calc(-50vw + 50%)',
          background: `
            radial-gradient(ellipse 80% 50% at 50% -20%, rgba(144, 202, 249, 0.12), transparent),
            radial-gradient(circle at 80% 80%, rgba(244, 143, 177, 0.06), transparent 50%),
            #212529
          `,
          position: 'relative',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: '1px',
            background: 'linear-gradient(90deg, transparent, rgba(144, 202, 249, 0.3), transparent)',
          },
        }}
      >
        <Container maxWidth="lg" sx={{ position: 'relative', overflow: 'visible' }}>
          <Box sx={{ textAlign: 'center', mb: { xs: 6, md: 8 } }}>
            <Typography
              variant="h1"
              component="h1"
              sx={{
                fontSize: { xs: '2.5rem', md: '3.5rem' },
                fontWeight: 700,
                mb: 2,
                background: 'linear-gradient(135deg, #FFFFFF 0%, #90caf9 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
              }}
            >
              {t('pricing.hero.title')}
            </Typography>

            <Typography
              variant="h6"
              sx={{
                color: '#ADB5BD',
                maxWidth: 700,
                mx: 'auto',
                fontSize: { xs: '1.1rem', md: '1.2rem' },
                lineHeight: 1.6,
                mb: 4,
              }}
            >
              {t('pricing.hero.subtitle')}
            </Typography>
          </Box>

          <PricingTable
            pricing={pricing}
            loading={pricingLoading}
          />
        </Container>
      </Box>

      {/* FAQ Section */}
      <FAQSection />

      {/* Final CTA */}
      <FinalCTA />
    </Box>
  );
}

export default Pricing;
